export * from "./stars-hotel-image";
